import { useState } from 'react';
import * as yup from 'yup';
import { PageStatus } from './LinkAccounts.types';
import { AccountDTO, usePlaidLink } from '../../../../../../_hooks/plaid/usePlaidLink';
import { useTransferMoneyContext } from '../../../../hooks/useTransferMoneyContext';

const onPlaidSuccess = ({ setPlaidData }) => (metadata, response) => {
  setPlaidData({
    itemId: response.itemId,
    accounts: metadata.accounts,
    institutionName: metadata.institution.name,
  });
};

const onPlaidStart = ({ setPageStatus }) => () => {
  setPageStatus(PageStatus.PlaidModalVisible);
};

const onPlaidExit = ({ onClose }) => () => {
  onClose();
};

const onPlaidHandoff = ({ setPageStatus }) => () => {
  setPageStatus(PageStatus.AccountSelection);
};

export interface FormValues {
  selectedAccountId: string | null;
}

export const validation = yup.object().shape({
  selectedAccountId: yup
    .string()
    .nullable()
    .required('Please select an account'),
});

interface PlaidData {
  itemId: string;
  accounts: AccountDTO[];
  institutionName: string;
}

interface UsePlaidAccountsModalParams {
  onClose(): void;
}

export const usePlaidAccountsModal = ({ onClose }: UsePlaidAccountsModalParams) => {
  const [pageStatus, setPageStatus] = useState<PageStatus>(PageStatus.PlaidLoading);

  const [plaidData, setPlaidData] = useState<PlaidData | null>(null);

  const { clientId } = useTransferMoneyContext();

  const plaidLink = usePlaidLink({
    clientId,
    isAccountVerification: true,
    onSuccess: onPlaidSuccess({ setPlaidData }),
    onStart: onPlaidStart({ setPageStatus }),
    onExit: onPlaidExit({ onClose }),
    onHandOff: onPlaidHandoff({ setPageStatus }),
  });

  return {
    data: {
      pageStatus,
      plaidLink,
      plaidData,
    },
  };
};
